import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { MODULES } from "@/portal/modulesData";
import { Check, ArrowRight, Circle } from "lucide-react";

export default function Training() {
  const { progress, refreshProgress } = useAuth();
  const done = new Set(progress?.modules_completed || []);

  const toggle = async (id, completed) => {
    await api.post("/progress/module", { module_id: id, completed });
    refreshProgress();
  };

  return (
    <div data-testid="training-page">
      <div className="eyebrow" style={{ color: "#2038E6" }}>The Training</div>
      <h1 className="h-display" style={{ fontSize: "clamp(32px,5vw,48px)", marginTop: 8 }}>7 Modules</h1>
      <p style={{ color: "var(--muted)", marginTop: 10 }}>Work them in order. You can jump around, but the sequence is the fastest path.</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 26 }}>
        {MODULES.map((m) => {
          const isDone = done.has(m.id);
          return (
            <div key={m.id} className="card-paper" data-testid={`module-card-${m.id}`} style={{ padding: 20, display: "flex", gap: 16, alignItems: "center" }}>
              <button
                onClick={() => toggle(m.id, !isDone)}
                data-testid={`module-check-${m.id}`}
                aria-label={isDone ? "Mark incomplete" : "Mark complete"}
                style={{
                  width: 30, height: 30, borderRadius: 8, flexShrink: 0, cursor: "pointer",
                  border: isDone ? "none" : "1px solid var(--line)",
                  background: isDone ? "#2038E6" : "#fff", color: "#fff",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                {isDone ? <Check size={18} /> : <Circle size={12} color="#D9DDD6" />}
              </button>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="font-mono-plex" style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.08em" }}>Module {m.id}</div>
                <div className="font-archivo" style={{ fontWeight: 800, fontSize: 18 }}>{m.title}</div>
                <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 2 }}>{m.bigIdea}</p>
              </div>
              <Link to={`/portal/training/${m.id}`} data-testid={`module-open-${m.id}`} className="btn-outline" style={{ padding: "9px 16px", fontSize: 12, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                {isDone ? "Review" : "Start"} <ArrowRight size={14} />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
